<template>
  <div class="BasePopupA " @click.self="handleClickHideA" v-show="isPopupShowA">
    <div class="detail-box" id="delBoxA">
      <p class="title_box">分享至</p>
      <div class="tools_box">
        <div class="tool_item" @click="handleCardItemA">
          <i class="iconfont2 icon-tupian tupian"></i>
          <span>生成分享卡片</span>
        </div>
        <div class="tool_item" @click="handleCardItemB">
          <i class="iconfont2 icon-weixin weixin"></i>
          <span>分享好友</span>
        </div>
      </div>
      <div class="foot_box">
        <div class="back_box" @click="handleClickHideA">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import { _throttle } from '@/utils/debounce.js'
import { queryInstanceDetails } from '@/api/http/index'

export default {
  name: 'BasePopupA',
  data() {
    return {
      delBtnA: null,
      delBoxA: null,
      delBoxAH: null,
      isPopupShowA: false,
      instance: null,
      instanceName: '',
      spe: '', //特殊标识
      isHas: true
    }
  },
  created() {},
  mounted() {
    this.$EventBus.$on('openDelShare', (instanceName, spe = '', obj = {}) => {
      if (instanceName) {
        this.isHas = true

        this.spe = spe
        this.instanceName = instanceName
        const params = { instanceId: instanceName }
        queryInstanceDetails(params).then(
          res => {
            res || (this.isHas = false)
            this.instance = res
            this.getDomEl()
            this.delBoxA.classList.add('transition')
            // TODO
            setTimeout(() => {
              this.delBoxA.style.transform = `translate(0,0)`
            }, 0)
          },
          () => {
            // 错误处理
          }
        )
      } else {
        this.isHas = false
        this.instance = {
          instanceName: obj.name,
          properties: {
            description: obj.description
          }
        }
        this.getDomEl()
        this.delBoxA.classList.add('transition')
        // TODO
        setTimeout(() => {
          this.delBoxA.style.transform = `translate(0,0)`
        }, 0)
      }
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('openDelShare')
  },
  components: {},
  computed: {},
  methods: {
    // 准备工作
    getDomEl() {
      this.isPopupShowA = true

      this.delBtnA = document.getElementById('delBtnA')
      this.delBoxA = document.getElementById('delBoxA')
      // TODO
      setTimeout(() => {
        this.delBoxAH = this.delBoxA.offsetHeight
      }, 0)

      // 当过渡完成移除过渡效果
      this.delBoxA.addEventListener('transitionend', () => {
        this.delBoxA.classList.remove('transition')

        let oldY = this.delBoxA.style.transform.match(/\((.*)\)/)
        oldY = oldY ? oldY[1].split(',') : 0
        oldY = oldY ? oldY[1].replace(/px/g, '') * 1 : 0
        oldY = Math.abs(oldY)
        const standard = Math.round(this.delBoxAH / 4)
        if (oldY >= standard) {
          this.isPopupShowA = false
        }
      })
    },
    // 手指按下
    handleTouchStart(e) {
      e.preventDefault()
      // 拿到触摸点坐标
      const startY = e.touches[0].clientY
      const _run = _throttle(e => {
        const currentY = e.touches[0].pageY // 当前点击的点击位置的坐标值
        let moveY = currentY - startY
        if (moveY <= 0) moveY = 0 // 禁止向上拖动
        if (moveY >= this.delBoxAH) moveY = this.delBoxAH
        this.delBoxA.style.transform = `translate(0,${moveY}px)`
      }, 15)
      this.delBoxA.ontouchmove = _run
    },
    // 手指离开
    handleTouchend() {
      const { delBoxA, delBoxAH } = this

      let oldY = delBoxA.style.transform.match(/\((.*)\)/)
      oldY = oldY ? oldY[1].split(',') : 0
      oldY = oldY ? oldY[1].replace(/px/g, '') * 1 : 0
      oldY = Math.abs(oldY)

      const standard = Math.round(delBoxAH / 4)
      if (oldY >= standard) {
        delBoxA.classList.add('transition')
        delBoxA.style.transform = `translate(0,${delBoxAH}px)`
      } else {
        delBoxA.classList.add('transition')
        delBoxA.style.transform = `translate(0,0)`
      }
      delBoxA.ontouchmove = null

      if (oldY == 0) this.delBoxA.classList.remove('transition')
    },
    // 点击隐藏
    handleClickHideA() {
      this.delBoxA.classList.add('transition')
      this.delBoxA.ontouchmove = null
      delBoxA.style.transform = `translate(0,${this.delBoxAH}px)`
    },
    handleCardItemA() {
      this.handleClickHideA()
    },
    handleCardItemB() {
      // console.log('分享好友')
      // this.$linkWx({ url: '/pages/CreateImage' })
    }
  }
}
</script>

<style lang="scss" scoped>
.BasePopupA {
  overflow: hidden;

  position: absolute;
  top: 0;
  left: 0;
  z-index: 1003;

  width: 100%;
  height: 100%;
  background-color: transparent;
  font-size: 0.38rem;

  .detail-box {
    position: absolute;
    bottom: 0;
    left: 0;

    width: inherit;
    // height: 6.45rem;
    // height: 5.35rem;
    // padding: 0 0.94rem;
    background-color: #fff;
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;

    transform: translate(0, 500px);

    .title_box {
      color: #a3a3a3;
      height: 1.2rem;
      line-height: 1.5rem;
      text-align: center;
    }
    .tools_box {
      margin-bottom: 0.5rem;
      display: flex;
      justify-content: space-around;
      color: #878787;
      i {
        width: 1.5rem;
        height: 1.5rem;
        background-color: #f2f2f2;
        border-radius: 50%;
        font-size: 0.8rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      font-size: 0.8rem;
      .tool_item {
        width: 3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 0.38rem;
        gap: 0.2rem;
        .weixin {
          color: #01b16a;
        }
        .tupian {
          color: #a3a3a3;
        }
      }
    }

    .foot_box {
      border-top: 2px solid #d4d4d4;
      text-align: center;
      height: 1.2rem;
      line-height: 1.5rem;
      color: #878787;
    }
  }
  .transition {
    transition: 0.3s;
  }
}
</style>